import { MessageCircle } from "lucide-react";
import { WHATSAPP_LINK } from "../constants/config";

export const WhatsAppButton = () => {
  return (
    <a
      href={WHATSAPP_LINK}
      target="_blank"
      rel="noopener noreferrer"
      data-testid="floating-whatsapp-button"
      aria-label="Chat WhatsApp RismaCell"
      className="fixed bottom-6 right-6 z-50 w-14 h-14 md:w-16 md:h-16 rounded-full bg-[#25D366] flex items-center justify-center shadow-xl animate-wa-pulse hover:scale-110 active:scale-95 transition-transform"
    >
      <MessageCircle className="w-7 h-7 md:w-8 md:h-8 text-white" fill="white" strokeWidth={0} />
    </a>
  );
};
